<template>
  <div class="whiteUser">
    <div class="queryHeader">
      <van-nav-bar
        title="白名单"
        left-text="返回"
        left-arrow
        @click-left="goBack"
      />
    </div>
  <!-- 可滚动区域 -->
  <div class="content">
    <div class="search">
      <van-search
        v-model="value"
        show-action
        placeholder="请输入搜索服务站用户"
        @search="onSearch"
        @input="onSearch"
      >
        <template #action>
          <div @click="onSearch(value)">搜索</div>
        </template>
      </van-search>
      <van-divider />
    </div>

      <!-- 添加 -->
      <div class="addWhiteUser add-contact-card" role="button" tabindex="0" @click="onAdd">
        <van-icon name="add" class="van-add__left-icon"/>
        <div class="add-value add-value__alone">添加服务站用户</div>
        <van-icon name="arrow" class="van-add__right-icon"/>
      </div>
      <!-- 查询到的用户列表 -->
      <div class="addWhiteUser add-contact-card" role="button" tabindex="0" @click="onEdit(item)" 
        v-for="(item,index) in responseDataArray" :key="index">
      <van-icon name="user" class="user__left-icon"/>
      <div class="add-value add-value__alone"  >用户名：{{ item.name }}</div>
       <van-button @click.stop="onDelete(item)">删除</van-button>
      </div>
    </div>
    <!-- 编辑 -->
    <van-overlay :show="exitShow" @click="exitShow=false">
      <div class="whiteListWrapper" @click.stop>
        <div class="whiteListBlock">
          <van-form ref="whiteLIstForm">
          <div class="whiteListTitle">
            <span>编辑</span>
          </div>
              <van-field label="用户名：" v-model="showList.name" :disabled="whiteListDisabled"/>
            <van-field label="身份证号：" v-model="showList.idNo" disabled/>
            <van-field label="手机号码：" 
            v-model="showList.phone" 
            type="tel" 
            maxlength="11"
            :rules="[{required:true,pattern:/^1[3456789]\d{9}$/,message:'请输入正确的手机号码'}]"
            :disabled="whiteListDisabled"/>
            <van-field label="状态： " :disabled="whiteListDisabled" >
              <template #input>
                <van-radio-group v-model="showList.state" direction="horizontal" :disabled="whiteListDisabled">
                  <van-radio :name= 0 checked-color="#3399ff">正常</van-radio>
                  <van-radio :name= 1 checked-color="#3399ff">禁用</van-radio>
                </van-radio-group>
              </template>
            </van-field>
            <van-field label="创建时间： " v-model="showList.createTime" readonly disabled>
              {{ showList.createTime | formatTime }}</van-field>
            </van-form>
          <div style="margin: 16px;">
            <van-row style="margin-top: 2%;">
              <van-col :span="12">
                <van-button @click="cancel" plain hairline type="info" class="buttons">取消</van-button>
              </van-col>
              <van-col :span="12">
                <van-button @click="confirm" plain hairline type="info" class="buttons">确认</van-button>
              </van-col>
            </van-row>
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- 新增 -->
    <van-overlay :show="addShow" @click="addShow=false" >
      <div class="whiteListWrapper" @click.stop> 
      <div class="whiteListBlock"  >
        <van-form ref="addWhiteList">
        <div class="whiteListTitle">
          <span>添加服务站用户</span>
        </div>
        <van-field label="用户名：" v-model="addWhiteListForm.name" placeholder="请输入用户名"
        :rules="[{required:true,message:'请输入用户名'}]"/>
        <van-field label="身份证号：" v-model="addWhiteListForm.idNo" 
        placeholder="请输入身份证号"
        :rules="[{required:true, pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '请输入正确的身份证号码', }]"
        :maxlength="18"/>
        <van-field label="手机号：" v-model="addWhiteListForm.phoneNo" 
          placeholder="请输入手机号"
          :rules="[{required:true,pattern:/^1[3456789]\d{9}$/,message:'请输入正确的手机号码'}]"
          type="tel"
          maxlength="11"/>
        <van-field label="状态： " >
          <template #input>
            <van-radio-group v-model="addWhiteListForm.state" direction="horizontal">
              <van-radio :name= 0 checked-color="#3399ff">正常</van-radio>
              <van-radio :name= 1 checked-color="#3399ff">禁用</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </van-form>
        <div style="margin: 16px;" >
            <van-row style="margin-top: 3%;">
              <van-col :span="12">
                <van-button @click="addCancel" plain hairline type="info" class="buttons">取消</van-button>
              </van-col>
              <van-col :span="12">
                <van-button @click="addConfirm" plain hairline type="info" class="buttons">确认</van-button>
              </van-col>
            </van-row>
          </div>
        </div>
      </div>
    </van-overlay>

  </div>
</template>

<script>
import {QueryWhiteList,ModifyWhiteList,AddWhiteList,DeleteWhiteList} from '@/my_js/HttpRequest.js'
import {formatTime} from '@/utils/date.js'
import { Dialog } from 'vant'
import { Notify } from 'vant'
import{mapMutations} from 'vuex'
import store from '../../store/index'
export default {
  mounted(){
    this.onSearch()
  },
  components:{

  },
  filters:{
    formatTime:function(inputTime){
     return formatTime(inputTime)
    },
    formatType:function(inputValue){
      if(inputValue == 0){
        return '超级管理员'
      }else if (inputValue == 1){
        return '管理员'
      }else if (inputValue == 2){
        return '职员'
      }
    },
    formatState:function(inputState){
      if(inputState == 0){
        return '正常'
      }else if (inputState == 1){
        return '禁用'
      }
    }
  },
  data(){
    return{
      value:'',//搜索内容
      responseDataArray:[],//响应数据
      exitShow:false,//编辑显示
      showList:[],//编辑展示的数据
      addWhiteListForm:{
        name:'',//用户名
        idNo:'',//身份证号
        phoneNo: '',//手机号
        state: 0,//状态
      },
      addShow:false,//添加用户
      whiteListDisabled:false,
    }
  },
  methods:{
    // ...mapMutations(['setUserName']),
    // 返回
    goBack(){
      console.log('返回管理员首页');
      this.$router.push('/manager')
    },
    // 查询用户
    onSearch(val){
      console.log(val);
      const data = {
        name: this.value,
        state: -1,
      }
      console.log(JSON.stringify(data));
      QueryWhiteList(data).then(res => {
        console.log('查询白名单用户res',res);
        this.responseDataArray = res.data
      })
    },
    // 添加用户
    onAdd(){
      console.log('添加白名单用户');
      // this.addShow = true
      if(store.state.role == 0 || store.state.role == 1){
        this.addShow = true
      }else{
        Notify({type:'warning',message:'当前账号没有添加白名单用户权限'})
      }
      // this.setUserName('admin')
      // store.commit('setUserName', 'admin');
      // // store.commit('setUserName', 'admin');
      // console.log('setUserName', store.state.userName)
    },
    addConfirm(){
      console.log(this.addWhiteListForm);
      this.$refs.addWhiteList.validate()
      .then(valid => {
        // 验证通过
        console.log('验证通过');
        AddWhiteList(this.addWhiteListForm).then(res =>{
          console.log('添加服务站用户res',res);
          this.addShow = false
          this.addWhiteListForm={
            name:'',//用户名
            idNo:'',//身份证号
            phoneNo: '',//手机号
            state: 0,//状态
          },
          Notify({type:'success',message:'添加'+res.msg})
          this.onSearch()
        })
      })
      .catch(error => {
        // 验证不通过
        console.log('表单验证不通过：',error);
      })
    },
    addCancel(){
      console.log('取消添加用户');
      this.addShow = false
    },
    // 编辑
    onEdit(val){
      console.log('编辑用户');
      console.log(val);
      this.showList = val
      this.showList.createTime = formatTime(this.showList.createTime)
      this.exitShow = true
      if(store.state.role == 2){
        this.whiteListDisabled = true
      }
      console.log('修改前showList：',this.showList);
    },
     // 提交修改表单
     confirm(){
      let _this = this
      console.log('点击了确定修改');
      console.log('修改后showList：',this.showList);
      _this.$refs.whiteLIstForm.validate()
        .then(valid => {
          // 表单验证成功
          console.log('验证通过');
          const data = {
          idNo:this.showList.idNo,//身份证号
          name:this.showList.name,//用户名
          phoneNo:this.showList.phone,//手机号
          state:this.showList.state,//状态 0正常 1禁用
          }
          Dialog.confirm({
            title:'消息确认',
            message:`是否确定修改该用户的信息？`
          }).then(()=>{
            // 修改请求
            console.log('点击了确定');
            ModifyWhiteList(data).then(res => {
              console.log('修改res:',res);
              this.exitShow = false
              Notify({type:'success',message:'修改'+res.msg})
            })
          }).catch(error =>{
            console.log(error);
          })
              

        })
        .catch(error => {
            console.log('验证不通过');
            console.error('Validation failed:', error);
        });
    },
    // 取消修改
    cancel(){
        console.log('点击了取消修改');
        this.exitShow = false
        this.onSearch()
      },
    // 删除用户
    onDelete(val){
      console.log('删除用户');
      // 职员没有删除权限，超级管理员和管理员可以进行删除操作
      if(store.state.role == 2){
        Notify({type:'warning',message:'当前账号没有删除白名单用户权限'})
      }else if(store.state.role == 0 || store.state.role == 1){
        Dialog.confirm({
          title:'提示',
          message:`确认删除 ${val.name} ？`
        }).then(()=>{
          // 确认删除用户
          DeleteWhiteList(val).then(res =>{
          console.log('删除用户',res);
          Notify({type:'success',message:'删除'+res.msg})
          this.onSearch()
        })
        }).catch(error=>{
          console.log(error);
        })
      }else{
        Notify({type:'warning',message:'未知权限'})
      }
      // Dialog.confirm({
      //   title:'提示',
      //   message:`确认删除 ${val.name} ？`
      // }).then(()=>{
      //   // 确认删除用户
      //   DeleteWhiteList(val).then(res =>{
      //   console.log('删除用户',res);
      //   Notify({type:'success',message:'删除'+res.msg})
      //   this.onSearch()
      // })
      // }).catch(error=>{
      //   console.log(error);
      // })
    },
   
  }

}
</script>

<style lang="scss" >
.whiteUser{
  .van-nav-bar__left{
    left: 0;
  }
  .van-nav-bar .van-icon{
    color: #0283ef;
  }
  .van-nav-bar__text{
    color: #0283ef;
  }
  .van-search__action{
    color: #0283ef;
    font-size: 18px;
  }
  .addWhiteUser {
  position: relative;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
  color: #111;
  font-size: 25px;
  line-height: 50px;
  background-color: #fff;
}

.addWhiteUser::before {
  position: absolute;
  right: 0;
  left: 0;
  bottom: 0;
  height: 1px;
  // #e2e2e2
  // background: repeating-linear-gradient(-45deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #0283ef 0, #0283ef 45%, transparent 0, transparent 50%);
  background: repeating-linear-gradient(-180deg, #f0efef 0, #f0efef 20%, 
  transparent 0, transparent 25%, #f0efef 0, #f0efef 45%, transparent 0, transparent 50%);
  background-size: 150px;
  content: '';
}

.add-user-clickable {
  cursor: pointer;
}

.add-user-center {
  display: flex;
  align-items: center;
}
.add-value{
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-box-flex: 5;
  flex: 5;
}
.add-value__alone{
  color: #333;
  text-align: left;
  font-size: 16px;
  margin-left: 8px;
}

.add-contact-card {
  padding: 10px;
}

.van-add__left-icon {
  color: #0283ef;
  font-size: 35px;
}
.van-add__right-icon{
  margin-left: 10px;
  font-size: 18px;
  color: #999;
}

.van-add__left-icon, .van-add__right-icon {
  min-width: 30px;
  height: 50px;
  line-height: 50px;
}
.user__left-icon{
  line-height: 50px;
  font-size: 22px;
  
}
.whiteListWrapper{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .whiteListBlock{
    width: 90%;
    // height: 60%;
    border-radius: 8px;
    background-color: #fff;
    .whiteListTitle{
    margin-top: 3%;
    }

    .van-cell__value{
      text-align: left;
    }
    .buttons{
      width: 90%;
    }
  }

}
.van-dialog__confirm {
    background-color: #0094ff; /* 确认按钮背景色 */
    color: #fff; /* 确认按钮字体颜色 */
  }
</style>